import * as React from 'react';

import { Card, Col, Row } from 'antd';
import classNames from 'classnames';

interface MessageContainerProps extends React.PropsWithChildren<{}> {
  className?: string;
  title: string;
}

const MessageContainer: React.FC<MessageContainerProps> = ({
  title,
  className,
  children,
}) => {
  return (
    <Row
      className={classNames('message-container', className)}
      justify="center"
    >
      <Col lg={14} md={16} sm={18} xs={20}>
        <Card title={title}>{children}</Card>
      </Col>
    </Row>
  );
};

export default MessageContainer;
